module.exports = __webpack_public_path__ + "img/ຄ່ານ້ຳມັນ10-711x800.2444a67c.jpg";